export const AUTH_CHECK_STATE = 'AUTH_CHECK_STATE';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_CHECK_TIMEOUT = 'AUTH_CHECK_TIMEOUT';
export const AUTH_INITIATE_LOGOUT = 'AUTH_INITIATE_LOGOUT';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const GET_SITES_START = 'GET_SITES_START';
export const GET_SITES = 'GET_SITES';
export const GET_SITES_SUCCESS = 'GET_SITES_SUCCESS';
export const GET_SITES_FAIL = 'GET_SITES_FAIL';

export const SET_SELECTED_START = 'SET_SELECTED_START';
export const SET_SITE_SELECTED = 'SET_SITE_SELECTED';
export const SET_SELECTED_SUCCESS = 'SET_SELECTED_SUCCESS';
export const SET_SELECTED_FAIL = 'SET_SELECTED_FAIL';

export const SET_FAVORITE_START = 'SET_FAVORITE_START';
export const SET_FAVORITE_SITE = 'SET_FAVORITE_SITE';
export const SET_FAVORITE_SUCCESS = 'SET_FAVORITE_SUCCESS';
export const SET_FAVORITE_FAIL = 'SET_FAVORITE_FAIL';

export const GET_SITE_DATA_START = 'GET_SITE_DATA_START';
export const GET_SITE_DATA = 'GET_SITE_DATA';
export const GET_SITE_DATA_SUCCESS = 'GET_SITE_DATA_SUCCESS';
export const GET_SITE_DATA_FAIL = 'GET_SITE_DATA_FAIL';

export const GET_OOS_UNITS_START = 'GET_OOS_UNITS_START';
export const GET_OOS_UNITS = 'GET_OOS_UNITS';
export const GET_OOS_UNITS_SUCCESS = 'GET_OOS_UNITS_SUCCESS';
export const GET_OOS_UNITS_FAIL = 'GET_OOS_UNITS_FAIL';

export const REPORT_ISSUE_START = 'REPORT_ISSUE_START';
export const REPORT_ISSUE = 'REPORT_ISSUE';
export const REPORT_ISSUE_SUCCESS = 'REPORT_ISSUE_SUCCESS';
export const REPORT_ISSUE_FAIL = 'REPORT_ISSUE_FAIL';